// this file is generated by update_shopify_store_data.py at 2026-11-03 20:11:37.221464
var courses = [
    {
        "course_id": "F5E9B693-7E8B-F111-99B2-005056A7F5E9",
        "course_version": 1,
        "name": "AAENP - Pediatric Bundle",
        "course_type": 32,
        "author_information": "",
        "description": "Children are not small adults, and the stakes of getting it wrong are difficult to overstate. The Pediatric Bundle addresses the presentations that generate the most uncertainty in emergency and urgent care \u2014 head injury in infants and young children, toxic ingestions, behavioral health crises, and infectious diseases that are making a return. Every course is developed and delivered by experts in emergency care. \r\n\r\n6 Courses Included",
        "learning_objectives_html": "At the conclusion, participants should be able to:",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C8BA6766-CF89-F111-99B9-005056A7EBB6",
                "course_category_name": "AAENP - Pediatric - Curriculum",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - Pediatric Bundle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Medicine",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Acute Care Facility",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": [
            {
                "course_id": "04B58173-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Behavioral Health Emergencies",
                "course_type": 1,
                "author_information": "Kathleen Jordan, DNP, RN, FNP-BC, ENP-C, SANE-P, FAEN, FAANP",
                "description": "The focus of this presentation is to provide evidence-based information for clinical decision-making through a discussion of trauma informed strategies to conduct a patient centered interview.\r\n\r\nEmergency department visits for behavioral health problems in children and adolescents continues to escalate, with a dramatic increase over the past decade. The ED has been classified as a safety net for this patient population, however this places a huge burden on ED processes and throughput. This situation is complicated by limitations in the ED that effect the timely and comprehensive patient evaluation, and the shortage of available inpatient beds and outpatient services for those children and adolescents who need mental health care.\r\n\r\nIt is imperative that emergency care providers have the knowledge and skill set to provide high quality, safe and effective care for this ED population. The focus of this presentation is to provide evidence-based information for clinical decision-making through a discussion of trauma informed strategies to conduct a patient centered interview, including essential collateral information and ancillary studies. Discussion will also include differentiating a medical versus psychiatric emergency in children and adolescents. The presentation will conclude with a discussion of the most common pediatric behavioral health problems encountered in the ED.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the impact of pediatric behavioral health emergencies on ED processes and throughput.</li>\r\n    <li>Identify goals of care for quality and safety for the pediatric patient with a behavioral health emergency in the ED.</li>\r\n    <li>Differentiate medical versus psychiatric disorders in pediatric patients in the ED.</li>\r\n    <li>Describe the emergency management of patients with the following behavioral health emergencies: aggression and violence; autism spectrum disorder, serotonin syndrome and complications related to COVID19.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5936B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Behavioral Health Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4F12A4B3-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Toxicological Emergencies: I only turned my back for one second!",
                "course_type": 1,
                "author_information": "Michael Schill III, DNP, FNP-BC, ENP-C, CEN, CFRN, MICN",
                "description": "Each day, we are unaware of some dangers around the house. It only takes a moment for a pediatric patient to get into something potentially harmful. We have all heard the phrase from a parent: \"I only turned my back for one second.\" This presentation will provide a review of the most common harmful household items and common medications. Whether you work in the Emergency Department or Urgent Care, this will help to review common signs and symptoms and up-to-date treatment. This interactive case scenario-based presentation will review and discuss pharmacological and non-pharmacological treatment modalities.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss the epidemiology of household ingestions in the pediatric population</li>\r\n    <li>Describe evaluation and management of potentially fatal ingestion of a single prescription medication</li>\r\n    <li>Identify common non-toxic toys that can still be toxic to the pediatric population</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "4D1A9C4B-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Measles: A Rash from the Past",
                "course_type": 1,
                "author_information": "Michael Gooch, DNP, APRN, CCP, ACNP-BC, FNP-BC, ENP-C",
                "description": "The course will examine the current Measles outbreak and implications for Emergency and Urgent Care Providers.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Examine Measles epidemiology and pathophysiology.</li>\r\n    <li>Discuss Measles diagnostics and plan of care pearls.</li>\r\n    <li>Identify complications associated with Measles.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "3FC51DDC-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                        "course_category_name": "Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "662CDF16-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Emergency Presentations - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "A24C16B0-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Emergency Presentations Bundle",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.6,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "EEE7809D-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Pediatric Lyme Disease",
                "course_type": 1,
                "author_information": "Teresa Dodge, DNP, FNP-C, CEN",
                "description": "Lyme disease is prevalent in the United States, especially in the Northeast. In fact, cases are only increasing and spreading further south. Pediatric patients, specifically those between the ages of five and fourteen, have the highest incidence of infection. Diagnosing and treating Lyme disease in pediatric patients can also be tricky, even for the most experienced nurse practitioners - the classic Lyme rash isn\u2019t always a bullseye, and pediatric Lyme arthritis can mimic many other acute pediatric orthopedic diseases. To make things worse, in 2020, while we were all distracted by COVID, the Infectious Diseases Society of America (IDSA), the American Academy of Neurology (AAN), and the American College of Rheumatology (ACR) released an updated guideline for the management of Lyme disease. These updated guidelines significantly changed the treatment of some Lyme patients. This presentation will review Lyme disease in the pediatric population, its signs and symptoms, how to diagnose it, and how to treat it.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>At the conclusion of this presentation, attendees should be able to define Lyme disease.</li>\r\n    <li>At the conclusion of this presentation, attendees should be able to summarize the best testing and screening for Lyme in pediatric patients.</li>\r\n    <li>At the conclusion of this presentation, attendees should be able to summarize the pediatric treatment for Lyme disease and when to initiate prophylaxis.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "6F560093-37E7-11DD-B494-001517135513",
                        "course_category_name": "Infectious Diseases",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "B2E077CD-DE17-F111-99AB-005056A70840",
                "course_version": 1,
                "name": "Single Dose Killers: Pediatric Toxicology",
                "course_type": 1,
                "author_information": "Micheal Gooch, DNP, APRN, ACNP-BC, FNP-BC, FAANP, FAEN",
                "description": "Toxicological emergencies are commonly encountered in emergency care. Some are more serious than others. In pediatric patients, there are a few substance known as the single dose killers as it only takes a small amount to cause toxicity. This presentation will review these agents, discuss their clinical manifestations, and management priorities to allow emergency NPs to manage these patients more competently.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Identify some of the single dose killers in pediatric toxicology</li>\r\n    <li>Modify management plans to correct toxicities encountered in pediatric toxicology</li>\r\n    <li>Introduce mechanisms for alleviating secondary traumatic stress, compassion fatigue, and burnout among professionals who provide care to critically ill or injured patients.</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                        "course_category_name": "Physician (MD/DO)",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9B623ACF-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "415C7DA9-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - ENP Pharmacology Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "5E38CE86-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - ENP Pharmacology - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 1.0,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            },
            {
                "course_id": "2C348AA3-7816-F111-99A7-005056A7C0C7",
                "course_version": 1,
                "name": "Baby Trauma Drama: Initial Evaluation and Management of Minor Head Trauma in Infants & Children",
                "course_type": 1,
                "author_information": "Speaker: Ashton Glover, DNP, FNP-C, ENP-C, SANE-A and Amanda Hitt, MSN, FNP-BC",
                "description": "This course reviews the typical clinical findings associated with minor head trauma in infants and young children and outlines a systematic approach to initial evaluation in the emergency department. Learners will develop practical skills in risk stratification and decision-making by applying the PECARN head trauma algorithm to infant cases, with an emphasis on identifying children at low risk for clinically significant traumatic brain injury while minimizing unnecessary imaging.",
                "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Discuss common findings associated with minor head trauma in infants and young children\r\n    </li>\r\n    <li> Describe the initial evaluation of infants and young children presenting to the emergency department with minor head trauma\r\n    </li>\r\n    <li>Apply the PECARN algorithm to a case of minor, infant head trauma</li>\r\n</ul>",
                "course_outline_html": "",
                "credit_info": "-",
                "categories": [
                    {
                        "course_category_id": "8C2AEAC8-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D1051744-2226-E711-9EDE-005056B14F90",
                        "course_category_name": "Pediatric Care",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "19D918B6-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                        "course_category_name": "Emergency",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "B8391A67-3160-F111-99AE-005056A7327D",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "E5A9019D-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - Pediatric Bundle",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "F55315B0-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Essential Concepts for Emergency Nurse Practitioners - Courses",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                        "course_category_name": "Nurse Practitioner",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Pediatrics",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "512CB365-6DC3-E911-814D-005056B14D10",
                        "course_category_name": "Injuries",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "D3F6527A-6516-F111-99A7-005056A7C0C7",
                        "course_category_name": "AAENP - American Academy of Emergency Nurse Practitioners",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                        "course_category_name": "Emergency Services",
                        "is_system_course_category": null
                    },
                    {
                        "course_category_id": "9106255A-CF89-F111-99B9-005056A7EBB6",
                        "course_category_name": "AAENP - Pediatric - Courses",
                        "is_system_course_category": null
                    }
                ],
                "ce_accreditation": {
                    "accrediting_body_name": "BON; BON-CNA",
                    "accreditation_statement": "American Academy of Emergency Nurse Practitioners (AAENP) is an approved continuing education provider through the Alabama Board of Nursing (ABNP#1571, exp 8/2027)",
                    "course_level_accreditation_statement": "",
                    "credit_display_name": "CNE",
                    "credit_units": 0.5,
                    "credit_unit_display_name": "Contact Hour(s)"
                },
                "sub_courses": []
            }
        ]
    }
];